import { Platform, StyleSheet } from 'react-native'

import { theme } from '../theme'
import { WEB_HOVER_TRANSITION } from '../src/shared/constants/animations'

export const privacyControlsRouteStyles = StyleSheet.create({
  webPageRoot: {
    width: '100%' as never,
    minHeight: '100vh' as never,
    backgroundColor: theme.background.card,
  },
  container: {
    flex: 1,
    backgroundColor: theme.background.card,
    ...(Platform.OS === 'web' && {
      minHeight: '100vh' as never,
    }),
  },
  scrollContent: {
    flexGrow: 1,
  },
  contentColumn: {
    paddingHorizontal: Platform.OS === 'web' ? 24 : 20,
    paddingTop: Platform.OS === 'web' ? 48 : 40,
    paddingBottom: Platform.OS === 'web' ? 64 : 48,
    maxWidth: 720,
    width: '100%',
    alignSelf: 'center',
  },
  webContentRoot: {
    width: '100%',
    paddingHorizontal: 24,
    paddingTop: 48,
    paddingBottom: 64,
    maxWidth: 720,
    alignSelf: 'center',
  },
  backLink: {
    alignSelf: 'flex-start',
    marginBottom: Platform.OS === 'web' ? 28 : 24,
    paddingVertical: 8,
    paddingHorizontal: 4,
    ...(Platform.OS === 'web' && {
      cursor: 'pointer' as never,
      transition: WEB_HOVER_TRANSITION as never,
    }),
  },
  backLinkPressed: {
    opacity: 0.75,
  },
  backLinkHovered: {
    opacity: 0.9,
  },
  backLinkText: {
    fontSize: Platform.OS === 'web' ? 16 : 15,
    fontWeight: '600',
    color: theme.primaryLight,
  },
  title: {
    fontSize: Platform.OS === 'web' ? 36 : 28,
    fontWeight: '800',
    color: theme.white,
    marginBottom: 10,
    textAlign: 'left',
  },
  subtitle: {
    color: theme.gray[600],
    fontSize: Platform.OS === 'web' ? 17 : 15,
    marginBottom: Platform.OS === 'web' ? 28 : 22,
    lineHeight: Platform.OS === 'web' ? 28 : 24,
  },
  section: {
    marginBottom: Platform.OS === 'web' ? 18 : 16,
    borderWidth: 1,
    borderColor: theme.gray[300],
    borderRadius: 12,
    backgroundColor: theme.background.cardElevated,
    padding: 14,
  },
  sectionTitle: {
    fontSize: Platform.OS === 'web' ? 19 : 17,
    fontWeight: '700',
    color: theme.white,
    marginBottom: 8,
  },
  sectionHint: {
    color: theme.gray[600],
    fontSize: Platform.OS === 'web' ? 15 : 14,
    lineHeight: Platform.OS === 'web' ? 22 : 20,
  },
  rowBetween: {
    marginTop: 10,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  exportButton: {
    marginTop: 12,
    borderRadius: 10,
    minHeight: 44,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.primary,
  },
  exportButtonDisabled: {
    opacity: 0.7,
  },
  exportButtonPressed: {
    opacity: 0.85,
  },
  exportButtonText: {
    color: theme.white,
    fontSize: 14,
    fontWeight: '700',
  },
  helperText: {
    marginTop: 10,
    color: theme.gray[500],
    fontSize: 13,
    lineHeight: 20,
  },
  deleteAccountSection: {
    marginTop: Platform.OS === 'web' ? 8 : 6,
    marginBottom: Platform.OS === 'web' ? 18 : 16,
    borderWidth: 1,
    borderColor: theme.gray[300],
    borderRadius: 12,
    backgroundColor: theme.background.cardElevated,
    padding: 0,
    overflow: 'hidden',
  },
  deleteAccountRow: {
    paddingVertical: Platform.OS === 'web' ? 16 : 14,
    paddingHorizontal: 14,
    ...(Platform.OS === 'web' && {
      cursor: 'pointer' as never,
      transition: WEB_HOVER_TRANSITION as never,
    }),
  },
  deleteAccountRowPressed: {
    opacity: 0.85,
  },
  deleteAccountRowHovered: {
    backgroundColor: theme.gray[300],
  },
  deleteAccountRowLabel: {
    fontSize: Platform.OS === 'web' ? 16 : 15,
    fontWeight: '700',
    color: theme.error,
  },
  deleteAccountRowHint: {
    marginTop: 6,
    color: theme.gray[500],
    fontSize: Platform.OS === 'web' ? 14 : 13,
    lineHeight: Platform.OS === 'web' ? 20 : 18,
  },
})

